import { noop } from 'utils/Mocks'

function wrap(handler = noop) {
  return function (e) {
    handler(e.data.global.clone())
  }
}

export function enableDrag(object, handlers) {
  const start = wrap(handlers.start)
  const move = wrap(handlers.move)
  const stop = wrap(handlers.stop)

  let id = Number.NaN

  function on(event) {
    if (isNaN(id)) {
      id = event.data.pointerId
      start(event)
      object.on('pointermove', move)
    }
  }

  function off(event) {

    if (id == event.data.pointerId) {
      id = Number.NaN
      stop(event)

      object.off('pointermove', move)
    }
  }

  object.interactive = true
  object.buttonMode = true
  object.on('pointerdown', on)
  object.on('pointerup', off)
  object.on('pointerupoutside', off)
}
